import { setDatadogUser } from '@/datadog'

export const isAuthenticated = () => {
  return localStorage.getItem('access_token') !== null
}

export const setAccessToken = accessToken => {
  localStorage.setItem('access_token', accessToken)
}

export const getAccessToken = () => {
  return localStorage.getItem('access_token')
}

export const setRefreshToken = refreshToken => {
  localStorage.setItem('refresh_token', refreshToken)
}

export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token')
}

export const setRootClinicId = rootClinicId => {
  localStorage.setItem('root_clinic_id', rootClinicId)
}

export const getRootClinicId = () => {
  const rootClinicId = localStorage.getItem('root_clinic_id')
  const trimmed = rootClinicId ? rootClinicId.trim() : null
  if (!trimmed || trimmed === 'null') return null
  return trimmed
}

export const setUnityId = unityId => {
  localStorage.setItem('unity_id', unityId)
}

export const getUnityId = () => {
  const unityId = localStorage.getItem('unity_id')
  return unityId && unityId !== 'null' ? unityId : null
}

export const setClarityIdentifier = email => {
  try {
    if (email && window.clarity) {
      window.clarity('identify', email)
    }
  } catch (e) {
    console.error('Error setting Clarity identifier:', e)
  }
}

export const setCurrentUser = user => {
  localStorage.setItem('user', JSON.stringify(user))
  if (user && user.email) {
    setClarityIdentifier(user.email)
  }
  setDatadogUser(user)
}

export const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'))
}

export const updateCurrentUser = props => {
  const user = getCurrentUser()
  Object.assign(user, props)
  localStorage.setItem('user', JSON.stringify(user))
}

export const setCurrentClinic = (clinic, origin) => {
  localStorage.setItem('clinic', JSON.stringify(clinic))
  console.log('setCurrentClinic from', origin)
}

export const getCurrentClinic = () => {
  return JSON.parse(localStorage.getItem('clinic'))
}

export const getCallPanelGroup = () => {
  return localStorage.getItem('callPanelGroup') || null
}

export const userHasRole = role => {
  const clinic = getCurrentClinic()
  if (!clinic || !clinic.role) return false
  return clinic.role === role
}

export const userHasRoles = roles => {
  const clinic = getCurrentClinic()
  if (!clinic || !clinic.role) return false
  return roles.includes(clinic.role)
}

export const clearLocalStorage = () => {
  localStorage.clear()
}

export const setPermissions = permissions => {
  localStorage.setItem('permissions', JSON.stringify(permissions))
}

export const getPermissions = () => {
  return JSON.parse(localStorage.getItem('permissions'))
}

export const userHasPermission = key => {
  const permissions = getPermissions()
  if (!permissions || !permissions.length) return false
  return permissions.includes(key)
}

export const setCalendarView = (cpf, view) => {
  const calendarView = JSON.parse(localStorage.getItem('calendarView')) || {}
  calendarView[cpf] = view
  localStorage.setItem('calendarView', JSON.stringify(calendarView))
}

export const getCalendarView = cpf => {
  const calendarView = JSON.parse(localStorage.getItem('calendarView'))
  return calendarView && calendarView[cpf] ? calendarView[cpf] : 'timeGridWeek'
}

const parseCalendarIntervalStorage = () => {
  try {
    const raw = localStorage.getItem('calendarInterval')
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

const isLegacyCalendarIntervalFormat = value =>
  typeof value === 'number' && Number.isFinite(value)

const isNewCalendarIntervalFormat = value =>
  value != null &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  !(value instanceof Date)

export const setCalendarInterval = (clinicId, calendarInterval) => {
  const stored = parseCalendarIntervalStorage()
  const intervals =
    stored && isNewCalendarIntervalFormat(stored) ? { ...stored } : {}
  if (clinicId != null) {
    intervals[clinicId] = calendarInterval
  }
  localStorage.setItem('calendarInterval', JSON.stringify(intervals))
}

export const getCalendarInterval = clinicId => {
  const stored = parseCalendarIntervalStorage()
  if (stored == null) return null
  if (isLegacyCalendarIntervalFormat(stored)) {
    if (clinicId != null) {
      setCalendarInterval(clinicId, stored)
    }
    return stored
  }
  if (isNewCalendarIntervalFormat(stored) && clinicId != null) {
    const value = stored[clinicId]
    return value != null ? value : null
  }
  return null
}

export const getEditingUser = () => {
  return localStorage.getItem('editingUser') || null
}

export const setHasMultiunities = hasMultiunities => {
  localStorage.setItem('multiunities', hasMultiunities)
}

export const hasMultiunities = () => {
  return localStorage.getItem('multiunities') === 'true'
}

// ── Assinatura digital / Certificados ──

export const setSingItemAutentic = data => {
  localStorage.setItem('singItemAutentic', JSON.stringify(data))
}

export const getSingItemAutentic = () => {
  try {
    return JSON.parse(localStorage.getItem('singItemAutentic'))
  } catch {
    return null
  }
}


// ── Painel de chamadas ──

export const setCallPanelGroup = group => {
  localStorage.setItem('callPanelGroup', group)
}

// ── Preferências UI ──

export const setShowOrientationsButton = value => {
  localStorage.setItem('show_orientations_button', JSON.stringify(value))
}

export const getShowOrientationsButton = () => {
  try {
    return JSON.parse(localStorage.getItem('show_orientations_button'))
  } catch {
    return null
  }
}

export const setFilterToday = value => {
  localStorage.setItem('filterToday', JSON.stringify(value))
}

export const getFilterToday = () => {
  try {
    return JSON.parse(localStorage.getItem('filterToday'))
  } catch {
    return null
  }
}

export const setFilterSituation = value => {
  localStorage.setItem('filterSituation', JSON.stringify(value))
}

export const getFilterSituation = () => {
  try {
    return JSON.parse(localStorage.getItem('filterSituation'))
  } catch {
    return null
  }
}

export const getDoctorId = () => {
  return localStorage.getItem('doctorId') || null
}

export const setDoctorId = value => {
  localStorage.setItem('doctorId', value)
}

// ── Agenda / Schedule ──

export const setScheduleOptions = options => {
  localStorage.setItem('scheduleOptions', JSON.stringify(options))
}

export const getScheduleOptions = () => {
  try {
    return JSON.parse(localStorage.getItem('scheduleOptions')) || []
  } catch {
    return []
  }
}
